import Modal from 'src/components/Modal'
import MyCalendar from 'src/components/MyCalendar'
import Pagination from 'src/components/Pagination'
import TimeInput from 'src/components/TimeInput'
import LimitedTextArea from 'src/components/LimitedTextArea'
import HttpImg from 'src/components/HttpImg'
import HttpLink from 'src/components/HttpLink'
import PhotoSelector from 'src/components/PhotoSelector'

// register global components
const globalComponents = {
  install(Vue) {
    Vue.component(Modal.name, Modal)
    Vue.component(MyCalendar.name, MyCalendar)
    Vue.component(Pagination.name, Pagination)
    Vue.component(TimeInput.name, TimeInput)
    Vue.component(LimitedTextArea.name, LimitedTextArea)
    Vue.component(HttpImg.name, HttpImg)
    Vue.component(HttpLink.name, HttpLink)
    Vue.component(PhotoSelector.name, PhotoSelector)
  }
}

export default globalComponents
